import { useEffect, useState } from "react";
import { X, Sparkles } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";
import { toast } from "sonner";
import api from "../lib/api";

export default function EmailPopup() {
  const [show, setShow] = useState(false);
  const [email, setEmail] = useState("");

  useEffect(() => {
    if (localStorage.getItem("bb_popup_seen")) return;
    const timer = setTimeout(() => setShow(true), 14000);
    const onLeave = (e) => { if (e.clientY < 8) { setShow(true); document.removeEventListener("mouseout", onLeave); } };
    document.addEventListener("mouseout", onLeave);
    return () => { clearTimeout(timer); document.removeEventListener("mouseout", onLeave); };
  }, []);

  const close = () => { setShow(false); localStorage.setItem("bb_popup_seen", "1"); };

  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/newsletter", { email });
      toast.success("You're part of the Bedtime Buddies family now.");
      close();
    } catch {
      toast.error("Please enter a valid email address.");
    }
  };

  return (
    <AnimatePresence>
      {show && (
        <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
          className="fixed inset-0 z-[90] flex items-center justify-center bg-navy/40 p-4 backdrop-blur-sm"
          onClick={close} data-testid="email-popup-overlay">
          <motion.div
            initial={{ scale: 0.92, y: 24 }} animate={{ scale: 1, y: 0 }} exit={{ scale: 0.95, y: 12 }}
            transition={{ type: "spring", damping: 24 }}
            onClick={(e) => e.stopPropagation()}
            className="relative w-full max-w-md overflow-hidden rounded-[2rem] bg-white p-9 text-center shadow-2xl"
            data-testid="email-popup" role="dialog" aria-label="Join the Bedtime Buddies family">
            <div className="pointer-events-none absolute -top-16 left-1/2 h-40 w-40 -translate-x-1/2 rounded-full bg-blush blur-2xl" />
            <button onClick={close} aria-label="Close popup" data-testid="email-popup-close"
              className="absolute right-4 top-4 flex h-9 w-9 items-center justify-center rounded-full text-navy/40 hover:bg-blush">
              <X size={18} />
            </button>
            <Sparkles className="relative mx-auto text-pink" size={30} />
            <h3 className="relative mt-4 font-display text-3xl font-semibold text-navy">Meet the Buddies first.</h3>
            <p className="relative mt-3 text-sm leading-relaxed text-navy/60">
              Join the Bedtime Buddies family for launch updates, new characters and bedtime stories.
            </p>
            <form onSubmit={submit} className="relative mt-6 space-y-3" data-testid="email-popup-form">
              <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                placeholder="Parent's email address" data-testid="email-popup-input"
                className="w-full rounded-full border border-blush bg-cream px-5 py-3.5 text-sm text-navy placeholder:text-navy/35 focus:border-pink focus:outline-none" />
              <button type="submit" data-testid="email-popup-submit"
                className="w-full rounded-full bg-pink py-3.5 font-display font-semibold tracking-wide text-navy transition hover:bg-moon">
                JOIN THE FAMILY
              </button>
            </form>
            <p className="relative mt-4 text-xs text-navy/40">No spam. Just big hugs and brighter nights.</p>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
